import { render, staticRenderFns } from "./VerOrdenPago.vue?vue&type=template&id=444c7b3a&scoped=true&"
import script from "./VerOrdenPago.vue?vue&type=script&lang=js&"
export * from "./VerOrdenPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c7b3a",
  null
  
)

export default component.exports